import { RestResponse } from '../types/response/RestResponse';
import service from './RestService';
import { FileContent } from '../state/project/types';

const path = '/projects';

export interface UploadConfig {
  onUploadProgress: (event: ProgressEvent) => void;
}

class ProjectDocumentsService {
  getProjectDocument = (projectId: number, documentId: number): RestResponse<FileContent> =>
    service.get(`${path}/${projectId}/documents/${documentId}`);

  uploadProjectDocument = (
    projectId: number,
    fileId: number | null,
    file: FormData,
    config?: UploadConfig,
    isProjectPlan?: boolean
  ): RestResponse<null> => {
    const fullPath = fileId
      ? `${path}/${projectId}/documents?fileID=${fileId}${isProjectPlan ? '&isProjectPlan=true' : ''}`
      : `${path}/${projectId}/documents${isProjectPlan ? '?isProjectPlan=true' : ''}`;
    return service.post(fullPath, file, undefined, config);
  };

  deleteProjectDocument = (projectId: number, fileId: number) => service.delete(`${path}/${projectId}/documents/${fileId}`);

  getProjectDocuments = (projectId: number): RestResponse<any> => service.get(`${path}/${projectId}/documents`);

  setDefaultProjectImage = (projectId: number, imageId: number): RestResponse<null> => service.put(`${path}/${projectId}/image/${imageId}`);
}

export default new ProjectDocumentsService();
